<template>
  <div id="app">
    <div class="footer-margin-bottom">      
    	<navigation></navigation>
      <subnavigation></subnavigation>
      <router-view></router-view>
    </div>
    
    <footer2></footer2>
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';
//import Subnavigation from './components/Subnavigation-old.vue';
import Subnavigation from './components/Subnavigation.vue';
import Footer2 from './components/Footer.vue';

export default {
  components: {
  	Navigation,
  	Subnavigation,
    // Test,
  	Footer2
  }
};
</script>


// WEBPACK FOOTER //
// App.vue?591f66ec